import React from 'react';
import { Link } from 'react-router-dom';
import SubLayout from '../../components/Layout/SubLayout';
import strings from '../../components/Language';
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import "./reward.scss";

import NoDataFound from './../../assets/images/icons/no_data_found.svg';
import eye from './../../assets/images/icons/eye.png';

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import _, { filter, set } from 'lodash';
import moment from 'moment';
import LoaderContext from '../../components/Loader/LoaderContext.js';
import { Button, Modal } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

class RewardScreen extends React.Component {
	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			tabValue: 0,
			data: [],
			profit_data: [],
			profit_data_is_load: false,
			activation_reward: [],
			activation_reward_is_load: false,
			profit_reward: [],
			profit_reward_is_load: false,
			showModal: false,
			showModalData: {},
			TP_startDate: null,
			TP_endDate: null,
			TP_next_page_url: null,
			TP_prev_page_url: null,
			BQ_startDate: null,
			BQ_endDate: null,
			BQ_next_page_url: null,
			BQ_prev_page_url: null,
			PQ_startDate: null,
			PQ_endDate: null,
			PQ_next_page_url: null,
			PQ_prev_page_url: null,
			filterProfit: 0,
			filterProfitReward: 0,
		}
		this.handleChange = this.handleChange.bind(this);

	}

	handleChange(event, newValue) {
		const self = this;
		self.setState({ tabValue: newValue });
	};

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			this.setState({ access_token: token });
			setTimeout(() => {
				this.getData();
				this.getProfitReport();
				this.getActivationReward();
				this.getProfitReward();
			});
		}
	}

	getData() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;
		axios({
			method: 'GET',
			url: api.reward,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.data.error === 200) {
				self.setState({ data: ress.data.data });
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getProfitReport() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;
		var API_URL = api.profit_report;
		if (this.state.TP_startDate && this.state.TP_endDate) {
			API_URL = api.profit_report + "?start_date=" + (this.state.TP_startDate ? moment(this.state.TP_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.TP_endDate ? moment(this.state.TP_endDate).format("YYYY-MM-DD") : "");
		}
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.data.error === 200) {
				self.setState({
					profit_data: (ress.data.data && ress.data.data.data) ? ress.data.data.data : [],
					profit_data_is_load: true,
					filterProfit: ress.data.message,
					TP_next_page_url: ress.data.data.next_page_url,
					TP_prev_page_url: ress.data.data.prev_page_url,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getActivationReward() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;
		var API_URL = api.activation_reward;
		if (this.state.BQ_startDate && this.state.BQ_endDate) {
			API_URL = api.activation_reward + "?start_date=" + (this.state.BQ_startDate ? moment(this.state.BQ_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.BQ_endDate ? moment(this.state.BQ_endDate).format("YYYY-MM-DD") : "");
		}
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.status === 200) {
				self.setState({
					activation_reward: (ress.data.data) ? ress.data.data : [],
					activation_reward_is_load: true,
					filterActivationReward: ress.data.total_amount,
					BQ_next_page_url: (ress.data && ress.data.links && ress.data.links.next) ? ress.data.links.next : null,
					BQ_prev_page_url: (ress.data && ress.data.links && ress.data.links.prev) ? ress.data.links.prev : null,

				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			console.log(e)
			setLoading(false);
		});
	};

	getProfitReward() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;
		var API_URL = api.profit_reward;
		if (this.state.PQ_startDate && this.state.PQ_endDate) {
			API_URL = api.profit_reward + "?start_date=" + (this.state.PQ_startDate ? moment(this.state.PQ_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.PQ_endDate ? moment(this.state.PQ_endDate).format("YYYY-MM-DD") : "");
		}
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {

			if (ress.data && ress.status === 200) {
				self.setState({
					profit_reward: (ress.data.data) ? ress.data.data : [],
					profit_reward_is_load: true,
					filterProfitReward: ress.data.total_amount,
					PQ_next_page_url: (ress.data && ress.data.links && ress.data.links.next) ? ress.data.links.next : null,
					PQ_prev_page_url: (ress.data && ress.data.links && ress.data.links.prev) ? ress.data.links.prev : null,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getNextDataTP(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var API_URL = API;
		if (this.state.TP_startDate && this.state.TP_endDate) {
			API_URL = API + "&start_date=" + (this.state.TP_startDate ? moment(this.state.TP_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.TP_endDate ? moment(this.state.TP_endDate).format("YYYY-MM-DD") : "");
		}
		var self = this;
		self.setState({
			nextPageLink: "",
			prevPageLink: "",
		});
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.data.error === 200) {
				self.setState({
					profit_data: [...self.state.profit_data, ...ress.data.data.data],
					profit_data_is_load: true,
					filterProfit: ress.data.message,
					TP_next_page_url: ress.data.data.next_page_url,
					TP_prev_page_url: ress.data.data.prev_page_url,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getNextDataBQ(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var API_URL = API;
		if (this.state.BQ_startDate && this.state.BQ_endDate) {
			API_URL = API + "&start_date=" + (this.state.BQ_startDate ? moment(this.state.BQ_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.BQ_endDate ? moment(this.state.BQ_endDate).format("YYYY-MM-DD") : "");
		}
		var self = this;
		self.setState({
			nextPageLink: "",
			prevPageLink: "",
		});
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.status === 200) {
				self.setState({
					activation_reward: [...self.state.activation_reward, ...ress.data.data],
					activation_reward_is_load: true,
					filterActivationReward: ress.data.total_amount,
					BQ_next_page_url: (ress.data && ress.data.links && ress.data.links.next) ? ress.data.links.next : null,
					BQ_prev_page_url: (ress.data && ress.data.links && ress.data.links.prev) ? ress.data.links.prev : null,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getNextDataPQ(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var API_URL = API;
		if (this.state.PQ_startDate && this.state.PQ_endDate) {
			API_URL = API + "&start_date=" + (this.state.PQ_startDate ? moment(this.state.PQ_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.PQ_endDate ? moment(this.state.PQ_endDate).format("YYYY-MM-DD") : "");
		}
		var self = this;
		self.setState({
			nextPageLink: "",
			prevPageLink: "",
		});
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.status === 200) {
				self.setState({
					profit_reward: [...self.state.profit_reward, ...ress.data.data],
					profit_reward_is_load: true,
					filterProfitReward: ress.data.total_amount,
					PQ_next_page_url: (ress.data && ress.data.links && ress.data.links.next) ? ress.data.links.next : null,
					PQ_prev_page_url: (ress.data && ress.data.links && ress.data.links.prev) ? ress.data.links.prev : null,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	openModal = (data) => {
		this.setState({ showModalData: {} });
		setTimeout(() => {
			this.setState({
				showModal: true,
				showModalData: data
			});
		});
	};

	closeModal = () => {
		this.setState({ showModal: false });
	};

	handleChangeTP = (dates) => {
		const [startTP, endTP] = dates;
		this.setState({ TP_startDate: startTP, TP_endDate: endTP });
		if (this.props.onChange) {
			this.props.onChange({ TP_startDate: startTP, TP_endDate: endTP });
		}
		setTimeout(() => {
			if (this.state.TP_startDate && this.state.TP_endDate) {
				this.getProfitReport();
			} else if (!this.state.TP_startDate && !this.state.TP_endDate) {
				this.getProfitReport();
			}
		});
	};

	handleChangeBQ = (dates) => {
		const [startBQ, endBQ] = dates;
		this.setState({ BQ_startDate: startBQ, BQ_endDate: endBQ });
		if (this.props.onChange) {
			this.props.onChange({ BQ_startDate: startBQ, BQ_endDate: endBQ });
		}
		setTimeout(() => {
			if (this.state.BQ_startDate && this.state.BQ_endDate) {
				this.getActivationReward();
			} else if (!this.state.BQ_startDate && !this.state.BQ_endDate) {
				this.getActivationReward();
			}
		});
	};

	handleChangePQ = (dates) => {
		const [startPQ, endPQ] = dates;
		this.setState({ PQ_startDate: startPQ, PQ_endDate: endPQ });
		if (this.props.onChange) {
			this.props.onChange({ PQ_startDate: startPQ, PQ_endDate: endPQ });
		}
		setTimeout(() => {
			if (this.state.PQ_startDate && this.state.PQ_endDate) {
				this.getProfitReward();
			} else if (!this.state.PQ_startDate && !this.state.PQ_endDate) {
				this.getProfitReward();
			}
		});
	};

	render() {

		const { TP_startDate, TP_endDate, PQ_startDate, PQ_endDate, BQ_startDate, BQ_endDate } = this.state;

		return (
			<SubLayout data={{ "title": strings.reward_details }}>
				<div className='offset-md-4 col-md-4'>
					<Tabs
						value={this.state.tabValue}
						onChange={this.handleChange}
						variant="scrollable"
						scrollButtons="auto"
						aria-label="scrollable auto tabs example"
					>
						<Tab label={strings.Trading_Profit} />
						<Tab label={strings.bot_quantification} />
						<Tab label={strings.profit_quantification} />
					</Tabs>
					<SwipeableViews index={this.state.tabValue} onChangeIndex={(index) => this.setState({ tabValue: index })} style={{ minHeight: "calc(100vh - 150px)" }}>
						<div role="tabpanel" hidden={this.state.tabValue !== 0}>
							{this.state.tabValue === 0 && (
								<>
									{this.state.data && this.state.data.trading_profit ?
										<div className="list_item" style={{ background: "#5CBC7C" }}>
											<div className="row">
												<div className='col-12 text-center'>
													<div style={{ fontSize: 14, marginBlock: 5 }}>{strings.total_profit_earned}</div>
													<div style={{ fontSize: 28, marginBlock: 10 }}>
														{
															this.state.filterProfit == 0 ?
																(this.state.data.trading_profit && this.state.data.trading_profit.profit_today && this.state.data.trading_profit.profit_today > 0) ? "+" + Number.parseFloat(this.state.data.trading_profit.profit_today).toFixed(5) : Number.parseFloat(0).toFixed(5)
																:
																this.state.filterProfit
														}
													</div>
												</div>
											</div>
											<div className='row' style={{ padding: 10 }}>
												<div className='api_list_back_wallet'>
													<DatePicker
														selected={TP_startDate}
														onChange={this.handleChangeTP}
														startDate={TP_startDate}
														endDate={TP_endDate}
														selectsRange
														isClearable
														className="form-control text_box datepicker-input"
														style={{ width: "100%" }}
														placeholderText={strings.select_a_date_range_for_trading_profit}
														dateFormat="yyyy-MM-dd"
													/>
												</div>
											</div>

										</div>
										:
										<div className="text-center" style={{ marginTop: 25 }}>
											<img src={NoDataFound} alt="CTS Bot" width={100}></img>
										</div>
									}

									<div style={{ marginTop: 20 }}>
										{this.state.profit_data_is_load && this.state.profit_data && this.state.profit_data.length !== 0 ?
											<>
												{this.state.profit_data.map((item, i) =>
													<>
														<div className="list_item">
															<div className="row">
																<div className='col-4'>
																	<div className=''>{(item.created_at) ? moment(item.created_at).format("YYYY-MM-DD") : ''}</div>
																	<div className=''>{(item.created_at) ? moment(item.created_at).format("HH:mm:ss") : ''}</div>
																</div>
																<div className='col-4'>
																	<div className=''>
																		<span className=''>{strings.profit}: </span>
																		<span className='text_up'>{(item.amount) ? Number.parseFloat(item.amount).toFixed(5) : ''}</span>
																	</div>
																	<div className='' style={{ fontSize: 12 }}>{strings.pair}: {(item.pair) ? item.pair : ''}</div>
																</div>
																<div className='col-4' style={{ textAlign: "right" }}>
																	<div className=''>

																		<span>
																			{item.type == 0 ? "DCA" : ""}
																			{item.type == 1 ? "CTS" : ""}
																			{item.type == 2 ? "AI" : ""}
																		</span>
																	</div>
																	<div className=''>
																		<div onClick={() => this.openModal(item)}>
																			<span className='text-decoration-underline' style={{ cursor: "pointer" }}>
																				{strings.details}
																				<img src={eye} alt="CTS Bot" style={{ marginLeft: 5 }} width={17} height={17}></img>
																			</span>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</>
												)}
											</>
											:
											<></>
										}
									</div>

									{this.state.TP_next_page_url ?
										<div className='flex-center' style={{ justifyContent: "center" }}>
											<Button onClick={() => this.getNextDataTP(this.state.TP_next_page_url)} type="primary" className='btn rounded-sm btn-m text-uppercase font-700 mt-4 mb-3 btn-full '
												style={{ fontSize: 14, paddingBlock: 10, background: '#446CE3', color: "#FFF", borderRadius: 10 }}>
												{strings.Load_More}
											</Button>
										</div>
										: null}
								</>
							)}
						</div>
						<div role="tabpanel" hidden={this.state.tabValue !== 1}>
							{this.state.tabValue === 1 && (
								<>
									{this.state.data && this.state.data.bot_quantification ?
										<div className="list_item" style={{ background: "#5CBC7C" }}>
											<div className="row">
												<div className='col-12 text-center'>
													<div style={{ fontSize: 14, marginBlock: 5 }}>{strings.total_profit_earned}</div>
													<div style={{ fontSize: 28, marginBlock: 10 }}>
														{
															this.state.filterActivationReward == 0 ?
																(this.state.data.profit_quantification && this.state.data.bot_quantification.profit_today) ? Number.parseFloat(this.state.data.bot_quantification.profit_today).toFixed(5) : Number.parseFloat(0).toFixed(5)
																:
																this.state.filterActivationReward
														}
													</div>
												</div>
											</div>
											<div className='row' style={{ padding: 10 }}>
												<div className='api_list_back_wallet'>
													<DatePicker
														selected={BQ_startDate}
														onChange={this.handleChangeBQ}
														startDate={BQ_startDate}
														endDate={BQ_endDate}
														selectsRange
														isClearable
														className="form-control text_box datepicker-input"
														placeholderText={strings.select_a_date_range_for_bot_quantification}
														dateFormat="yyyy-MM-dd"
													/>
												</div>
											</div>
										</div>
										:
										<div className="text-center" style={{ marginTop: 25 }}>
											<img src={NoDataFound} alt="Api2" width={100}></img>
										</div>
									}

									<div style={{ marginTop: 20 }}>
										{this.state.activation_reward_is_load && this.state.activation_reward && this.state.activation_reward.length !== 0 ?
											<>
												{this.state.activation_reward.map((item, i) =>
													<>
														<div className="list_item">
															<div className="row">
																<div className='col-4'>
																	<div className=''>{(item.created_at) ? moment(item.created_at).format("YYYY-MM-DD") : ''}</div>
																	<div className=''>{(item.created_at) ? moment(item.created_at).format("HH:mm:ssA") : ''}</div>
																</div>
																<div className='col-8'>
																	<div className=''>
																		<span className='gray_color'>{strings.profit}: </span>
																		<span className='text_up'>{(item.amount) ? Number.parseFloat(item.amount).toFixed(5) : ''}</span>
																	</div>
																	<div className='gray_color' style={{ fontSize: 12 }}>{strings.description}: {(item.description) ? item.description : ''}</div>
																</div>
															</div>
														</div>
													</>
												)}
											</>
											:
											<></>
										}
									</div>

									{this.state.BQ_next_page_url && this.state.BQ_next_page_url != null ?
										<div className='flex-center' style={{ justifyContent: "center" }}>
											<Button onClick={() => this.getNextDataBQ(this.state.BQ_next_page_url)} type="primary" className='btn rounded-sm btn-m text-uppercase font-700 mt-4 mb-3 btn-full '
												style={{ fontSize: 14, paddingBlock: 10, background: '#446CE3', color: "#FFF", borderRadius: 10 }}>
												{strings.Load_More}
											</Button>
										</div>
										: null}
								</>
							)}
						</div>
						<div role="tabpanel" hidden={this.state.tabValue !== 2}>
							{this.state.tabValue === 2 && (
								<>
									{this.state.data && this.state.data.profit_quantification ?
										<div className="list_item" style={{ background: "#5CBC7C" }}>
											<div className="row">
												<div className='col-12 text-center'>
													<div style={{ fontSize: 14, marginBlock: 5 }}>{strings.total_profit_earned}</div>
													<div style={{ fontSize: 28, marginBlock: 10 }}>
														{
															this.state.filterProfitReward == 0 ?
																(this.state.data.profit_quantification && this.state.data.profit_quantification.profit_today) ? Number.parseFloat(this.state.data.profit_quantification.profit_today).toFixed(5) : Number.parseFloat(0).toFixed(5)
																:
																this.state.filterProfitReward
														}
													</div>
												</div>
											</div>
											<div className='row' style={{ padding: 10 }}>
												<div className='api_list_back_wallet'>
													<DatePicker
														selected={PQ_startDate}
														onChange={this.handleChangePQ}
														startDate={PQ_startDate}
														endDate={PQ_endDate}
														selectsRange
														isClearable
														className="form-control text_box datepicker-input"
														placeholderText={strings.select_a_date_range_for_Profit_quantification}
														dateFormat="yyyy-MM-dd"
													/>
												</div>
											</div>
										</div>
										:
										<div className="text-center" style={{ marginTop: 25 }}>
											<img src={NoDataFound} alt="CTS Bot" width={100}></img>
										</div>
									}

									<div style={{ marginTop: 20 }}>
										{this.state.profit_reward_is_load && this.state.profit_reward && this.state.profit_reward.length !== 0 ?
											<>
												{this.state.profit_reward.map((item, i) =>
													<>
														<div className="list_item">
															<div className="row">
																<div className='col-4'>
																	<div className=''>{(item.created_at) ? moment(item.created_at).format("YYYY-MM-DD") : ''}</div>
																	<div className=''>{(item.created_at) ? moment(item.created_at).format("HH:mm:ss") : ''}</div>
																</div>
																<div className='col-8'>
																	<div className=''>
																		<span className='gray_color'>{strings.profit}: </span>
																		<span className='text_up'>{(item.amount) ? Number.parseFloat(item.amount).toFixed(5) : ''}</span>
																	</div>
																	<div className='gray_color' style={{ fontSize: 12 }}>{strings.description}: {(item.description) ? item.description : ''}</div>
																</div>
															</div>
														</div>
													</>
												)}
											</>
											:
											<></>
										}
									</div>

									{this.state.PQ_next_page_url && this.state.PQ_next_page_url != null ?
										<div className='flex-center' style={{ justifyContent: "center" }}>
											<Button onClick={() => this.getNextDataPQ(this.state.PQ_next_page_url)} type="primary" className='btn rounded-sm btn-m text-uppercase font-700 mt-4 mb-3 btn-full '
												style={{ fontSize: 14, paddingBlock: 10, background: '#446CE3', color: "#FFF", borderRadius: 10 }}>
												{strings.Load_More}
											</Button>
										</div>
										: null}
								</>
							)}
						</div>
					</SwipeableViews>
				</div>

				<Modal
					open={this.state.showModal}
					onClose={() => this.closeModal()}
					className="itemModal reward-modal-root"
					style={{ overflow: 'scroll' }}
				>
					<div className="modal-dialog modal-dialog-centered reward-modal-dialog">
						<div className="modal-content dark-modal-overlay reward-detail-modal">
							<div className="reward-detail-header">
								<div className="reward-detail-subtitle">
									<span className="reward-detail-bot-tag">
										{this.state.showModalData.type === 0 ? "DCA" : ""}
										{this.state.showModalData.type === 1 ? "CTS" : ""}
										{this.state.showModalData.type === 2 ? "AI" : ""} {strings.bot}
									</span>
									<span>{strings.details}</span>
								</div>
								<button onClick={() => this.closeModal()} type="button" className="reward-detail-close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body reward-detail-body">
								<div className="reward-detail-hero">
									<div className="reward-detail-title">
										{(this.state.showModalData && this.state.showModalData.pair) ? this.state.showModalData.pair : ""}
									</div>
									<span>{strings.profit}</span>
									<strong>{Number.parseFloat(this.state.showModalData.amount).toFixed(5)}</strong>
								</div>
								<div className="reward-detail-grid border-0">
									<div className='reward-detail-row'>
										<span>{strings.coin_qty}</span>
										<strong>{Number.parseFloat((this.state.showModalData && this.state.showModalData.quantity && this.state.showModalData.quantity) ? this.state.showModalData.quantity : 0).toFixed(2)}</strong>
									</div>
									<div className='reward-detail-row'>
										<span>{strings.usdt_qty}</span>
										<strong>{Number.parseFloat((this.state.showModalData && this.state.showModalData.cost && this.state.showModalData.cost) ? this.state.showModalData.cost : 0).toFixed(2)}</strong>
									</div>
									<div className='reward-detail-row'>
										<span>{strings.average_buy_price}</span>
										<strong>{Number.parseFloat((this.state.showModalData && this.state.showModalData.data && this.state.showModalData.data.price) ? (this.state.showModalData.cost / this.state.showModalData.quantity) : 0).toFixed(5)}</strong>
									</div>
									<div className='reward-detail-row'>
										<span>{strings.sell_price}</span>
										<strong>{Number.parseFloat((this.state.showModalData && this.state.showModalData.data && this.state.showModalData.data.price) ? this.state.showModalData.data.price : 0).toFixed(5)}</strong>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal>

			</SubLayout>
		);
	}
}

export default RewardScreen;
